import React from 'react';
import { Box, Typography } from '@mui/material';
import { Legend as StyledLegend, LegendItem } from './styles';

export const Legend: React.FC = () => {
  return (
    <StyledLegend>
      <Typography variant="body2" color="text.secondary" sx={{ marginRight: 2 }}>Legend:</Typography>
      <LegendItem>
        <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: 'error.main' }} />
        <Typography>Pathogenic</Typography>
      </LegendItem>
      <LegendItem>
        <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: 'warning.main' }} />
        <Typography>VUS</Typography>
      </LegendItem>
      <LegendItem>
        <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: 'info.main' }} />
        <Typography>Drug Response</Typography>
      </LegendItem>
      <LegendItem>
        <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: 'info.main' }} />
        <Typography>Benign</Typography>
      </LegendItem>
    </StyledLegend>
  );
}; 